import * as yup from 'yup';

export const FIELD_REASON = 'reason';
export const FIELD_EXPLANATION = 'explanation';

export const ApplicationsDeclineValidationForm = yup.object().shape({
  [FIELD_REASON]: yup.string().required('error.required').trim(),
  [FIELD_EXPLANATION]: yup.string().required('error.required').trim(),
});
